import React from 'react';
import moment from 'moment';
import {
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

const CreditInvoiceTable = (props) => {

  const classes = useStyles();

  return (
    <TableContainer>
      <Divider/>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Customer ID</TableCell>
            <TableCell>Customer Name</TableCell>
            <TableCell>Credit Month</TableCell>
            <TableCell>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow key={props.info.displayId}>
            <TableCell component="th" scope="row">
              {props.info.displayId}
            </TableCell>
            <TableCell component="th" scope="row">{props.info.customerName}</TableCell>
            <TableCell component="th" scope="row">{moment(props.info.paymentDate).format("MMMM / YYYY")}</TableCell>
            <TableCell component="th" scope="row">{props.info.total}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br></br>
    </TableContainer>
  )
};

export default CreditInvoiceTable;